import styled from 'styled-components'
import { NavigationBoldDownIcon } from 'components/Common/Icons'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 14px;
  cursor: pointer;
  transform: ${props => (props.opened ? 'rotate(180deg)' : 'rotate(0deg)')};
`

const Arrow = props => {
  const { toggleOpened, opened } = props
  return (
    <Wrapper onMouseDown={toggleOpened} opened={opened}>
      <NavigationBoldDownIcon />
    </Wrapper>
  )
}

export default Arrow
